<template>
  <q-card class="elevation-1">
    <q-card-section class="q-px-2x-md q-py-lg">
      <slot></slot>
    </q-card-section>
  </q-card>
</template>

<script setup></script>
